import { USER_ROLES } from "../lib/supabase";
import { PAGE_ACCESS } from "../config/navigation.config";
import { canAccessPageByRole } from "./navigationUtils";

// Feature permissions by role
export const ROLE_PERMISSIONS = {
  CAMPAIGNS: [USER_ROLES.BRAND, USER_ROLES.CAUSE, USER_ROLES.INFLUENCER, USER_ROLES.ADMIN],
  MILESTONES: [USER_ROLES.BRAND, USER_ROLES.CAUSE, USER_ROLES.INFLUENCER, USER_ROLES.ADMIN],
  REPORTS: [USER_ROLES.BRAND, USER_ROLES.CAUSE, USER_ROLES.INFLUENCER, USER_ROLES.ADMIN],
  CREATE_DOT: [USER_ROLES.BRAND, USER_ROLES.CAUSE, USER_ROLES.INFLUENCER, USER_ROLES.ADMIN],
  BRANDS: [USER_ROLES.BRAND, USER_ROLES.CAUSE, USER_ROLES.INFLUENCER, USER_ROLES.ADMIN],
  CAUSES: [USER_ROLES.BRAND, USER_ROLES.CAUSE, USER_ROLES.INFLUENCER, USER_ROLES.ADMIN],
};

/** @deprecated Use PAGE_ACCESS from navigation.config.js */
export const RESTRICTED_PAGES = [...PAGE_ACCESS.generalRestricted];

export const hasRolePermission = (userRole, feature) => {
  if (!userRole || !feature) return false;
  if (userRole === USER_ROLES.ADMIN) return true;

  const allowedRoles = ROLE_PERMISSIONS[feature];
  if (!allowedRoles) return true;

  return allowedRoles.includes(userRole);
};

export const canAccessPage = (userRole, pathname) => {
  return canAccessPageByRole(userRole, pathname, PAGE_ACCESS);
};

/** @deprecated Use filterNavByRole from navigationUtils.js */
export const filterNavItemsByRole = (navItems, userRole) => {
  if (!userRole) return navItems;
  if (userRole === USER_ROLES.ADMIN) return navItems;

  if (userRole === USER_ROLES.GENERAL) {
    return navItems.filter((item) => {
      return ![...PAGE_ACCESS.generalRestricted].some((restrictedPath) =>
        item.href?.startsWith(restrictedPath)
      );
    });
  }

  if (userRole === USER_ROLES.BRAND || userRole === USER_ROLES.CAUSE) {
    return navItems.filter((item) => {
      return item.id !== "brands" && item.id !== "causes";
    });
  }

  return navItems;
};

export const getRoleName = (role) => {
  const roleNames = {
    [USER_ROLES.GENERAL]: "General User",
    [USER_ROLES.BRAND]: "Brand",
    [USER_ROLES.CAUSE]: "Cause",
    [USER_ROLES.INFLUENCER]: "Influencer",
    [USER_ROLES.ADMIN]: "Administrator",
  };
  return roleNames[role] || role;
};

export const canCreateCampaigns = (userRole) => hasRolePermission(userRole, "CAMPAIGNS");
export const canAccessMilestones = (userRole) => hasRolePermission(userRole, "MILESTONES");
export const canAccessReports = (userRole) => hasRolePermission(userRole, "REPORTS");
